import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
} from "@mui/material";
import { Column } from "@pages/Admin/Notifications/resource/table/table.header";

interface NotificationsSkeletonTableProps {
  visibleColumns: Column[];
}

export const NotificationsSkeletonTable: React.FC<NotificationsSkeletonTableProps> = ({
  visibleColumns,
}) => {
  return (
    <>
      <Table sx={{ borderCollapse: "separate", borderSpacing: "0 16px" }}>
        <TableHead sx={{ my: 10 }}>
          <TableRow sx={{ backgroundColor: "#FFF" }}>
            {visibleColumns.map((col) => (
              <TableCell
                key={col.id}
                sx={{
                  padding: "12px 16px",
                  minWidth: col.minWidth ?? "auto",
                  maxWidth: col.maxWidth ?? "auto",
                  textAlign: col.align ?? "left",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  {col.label}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, index) => (
            <TableRow key={index} sx={{ backgroundColor: "#FFF" }}>
              {visibleColumns.map((col) => (
                <TableCell key={col.id}>
                  <Skeleton variant="text" width="100%" height={24} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
